import BannerForm from "./BannerForm.container";

export default BannerForm;
